import {ProcessClientOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ChipPopoverInfoField} from 'ui-library/chips/ChipPopoverContent';

import {GetChipPopoverContentsArgs} from '../ChipUtilConstants';
import {getProcedureTemplateField} from '../procedures/getCommonFields';
import getProcedureRunChipPopoverFields from '../procedures/getProcedureRunChipPopoverContents';

export default function getRecipeRunChipPopoverFields({
  processTask,
  icon,
}: GetChipPopoverContentsArgs): Array<ChipPopoverInfoField> {
  return getProcedureRunChipPopoverFields({
    processTask,
    icon,
    procedureTemplateField: getProcedureTemplateField(processTask.procedureRun, ProcessClientOrigin.RECIPES),
  });
}
